import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import configureStore from "./store";
import * as serviceWorker from "./serviceWorker";
// import "./i18n";

import { Router } from "react-router-dom";
import I18n from "redux-i18n";
import { translations } from "./i18n/translations";


const renderApp = (response) => {
  let language = navigator.language;
  const myTranslations = response ? { "en-US": response } : translations;
  // To view(Or add) list of languages supported by application refer
  // file ./i18n/translations...
  const supportedLanguages = Object.keys(myTranslations);
  if (supportedLanguages.indexOf(language) < 0) {
    language = "en-US";
  }

  ReactDOM.render(
    <Provider store={configureStore()}>
      <Suspense fallback="loading">
        <I18n translations={myTranslations} initialLang={language}>
          <App />
        </I18n>
      </Suspense>
    </Provider>,
    document.getElementById("root")
  );
};

renderApp();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
